import { render } from "./BasicInformation.vue?vue&type=template&id=1746ef2d"
import script from "./BasicInformation.vue?vue&type=script&lang=js"
export * from "./BasicInformation.vue?vue&type=script&lang=js"

import "./BasicInformation.vue?vue&type=style&index=0&id=1746ef2d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__